import { LatLngLiteral } from "leaflet";

export enum CoordinatesType {
	POINT = "point",
	MULTIPOINT = "multipoint",
	AREA = "area",
	ROUTE = "route",
}

export interface ILocation {
	id: number;
	regionId: number | null;
	name: string;
	coordinatesType: CoordinatesType;
	coordinates: LatLngLiteral[];
	locationId?: number;
	createdAt?: string;
	updatedAt?: string;
}

export interface ILocationFormValues {
	name: string;
	coordinatesType: CoordinatesType;
	coordinates: LatLngLiteral[];
	locationId?: number;
}

export interface ILocationFilter {
	limit: number;
	offset?: number;
	searchTerm?: string;
}

export interface ILocationTable {
	items: ILocation[];
	totalCount: number;
}